import React from 'react';
export function Guarantee() {
  return <section className="py-20 px-6 bg-serene-blue text-center" data-id="element-63">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-64">
        <div className="w-32 h-32 mb-8 bg-white rounded-full p-4 shadow-lg flex items-center justify-center" data-id="element-65">
          <img src="https://cdn.magicpatterns.com/uploads/mDsoEjmUTeqTpRyrt8Mjku/Minimalist_flat_design_202604112128.png" alt="Garantía" className="w-full h-full object-contain" data-id="element-66" />
        </div>

        <h2 className="font-fredoka text-3xl md:text-5xl text-white mb-6" data-id="element-67">
          Garantía Total de 7 Días
        </h2>

        <p className="text-xl text-white/90 font-medium mb-10 leading-relaxed" data-id="element-68">
          Si en 7 días no ves un cambio real en el ambiente espiritual de tu
          hogar, te devolvemos cada peso. Sin preguntas, sin formularios, sin
          drama. El riesgo es 100% nuestro.
        </p>

        <a href="https://pequeguia.lat/cart/42347593236583:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-sage-green hover:bg-gray-50 font-bold text-xl py-4 px-10 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300" data-id="element-69">
          PROBAR SIN RIESGO POR $3.900
        </a>
      </div>
    </section>;
}